import React from 'react'
import { Modal, ModalHeader } from 'reactstrap';
import { DeleteCulture } from './DeleteCulture';
import { FormCulture } from './FormCulture';
import { Dialog } from 'primereact/dialog';

export const ModalCulture = (props) => {

    const {
        modal, modalTitle, closeDialog, method,
        validaciones,
        culture, bacteriums, bacteriumsSelected, onChangeBacterium,
        handleInputChange, loading,
        saveCreate, saveUpdate, saveDelete
    } = props;

    return (
    <Dialog 
            header={modalTitle}
            visible={modal}
            onHide={closeDialog}
            closable={true}
            modal
            blockScroll
            className='large-dialog'
        >

            {
                method === "create"
                    ? <FormCulture
                        button={"Crear bacteria"}
                        {...{ closeDialog, loading, handleInputChange, validaciones, methodAction: saveCreate, culture, bacteriums, bacteriumsSelected, onChangeBacterium, }}
                    />
                    : (method === "update")
                        ?
                        <FormCulture
                            button={"Actualizar bacteria"}
                            {...{ closeDialog, loading, handleInputChange, validaciones, methodAction: saveUpdate, culture, bacteriums, bacteriumsSelected, onChangeBacterium, }} />
                        :
                        <DeleteCulture {...{ closeDialog, loading, culture, saveDelete }} />
            }
        </Dialog>
    )
}
